import React from 'react';

import Placeholder from 'components/consumer/Placeholder';
import RatingAndReviewsPlaceholder from 'components/consumer/RatingAndReviews/RatingAndReviewsPlaceholder';
import PDPPriceAndFinancePlaceholder from './PDPPriceAndFinancePlaceholder';

const PDPNameSectionPlaceholder = () => (
  <>
    <div className="flex flex-row items-center">
      <h1 className="text-xl font-bold text-gray md:text-2xl md:font-bold pl-5 pr-5 md:pl-[3.333vw] md:pr-[3.333vw] lg:pl-0 lg:pr-0 mb-1.5 md:mt-10">
        <Placeholder
          type="rect"
          loading
          className="!w-full lg:!w-[310px]"
          style={{
            height: '23px',
          }}
        />
      </h1>
    </div>

    <div className="pl-5 pr-5 md:pl-[3.333vw] md:pr-[3.333vw] lg:pl-0 lg:pr-0">
      <RatingAndReviewsPlaceholder />
    </div>

    <div className="bg-white pt-4 px-0 pb-3 sticky top-0 z-[1001] lg:items-center lg:flex lg:justify-between lg:px-0 lg:py-5 pl-5 pr-5 md:pl-[3.333vw] md:pr-[3.333vw] lg:pl-0 lg:pr-0">
      <PDPPriceAndFinancePlaceholder />
    </div>
  </>
);

export default PDPNameSectionPlaceholder;
